import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { inr, dmy } from "@/lib/proforma";

const STATUS = { Open: "bg-amber-100 text-amber-800", Cleared: "bg-emerald-100 text-emerald-800", "Not in AR": "bg-slate-100 text-slate-600" };

export function PIInvoicePicker({ invoices, selected, onToggle, onAll }) {
  const all = invoices.length > 0 && invoices.every((i) => selected.has(i.billing_doc));
  return (
    <div className="rounded-lg border border-slate-200 bg-white" data-testid="pi-invoice-picker">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-100">
        <label className="flex items-center gap-2 text-sm font-semibold text-slate-800">
          <Checkbox checked={all} onCheckedChange={(v) => onAll(!!v)} data-testid="pi-select-all" />
          Invoices found ({invoices.length}) — tick the ones for this PI
        </label>
        <span className="text-xs text-slate-500">{selected.size} selected</span>
      </div>
      <div className="max-h-64 overflow-y-auto divide-y divide-slate-100">
        {invoices.map((i) => (
          <label key={i.billing_doc} className="flex items-center gap-3 px-4 py-2 text-sm hover:bg-slate-50 cursor-pointer" data-testid={`pi-inv-${i.billing_doc}`}>
            <Checkbox checked={selected.has(i.billing_doc)} onCheckedChange={() => onToggle(i.billing_doc)} data-testid={`pi-inv-check-${i.billing_doc}`} />
            <span className="font-mono font-semibold text-slate-900 w-28">{i.billing_doc}</span>
            <span className="text-slate-500 w-24">{dmy(i.date)}</span>
            <span className="text-slate-600 flex-1 truncate">{i.lines.map((l) => l.description).join(" · ")}</span>
            {i.po_no && <span className="text-xs text-slate-500">PO {i.po_no}</span>}
            <Badge className={`${STATUS[i.ar_status] || STATUS["Not in AR"]} border-0`}>{i.ar_status}</Badge>
            <span className="tabular-nums font-medium w-32 text-right">{inr(i.net)}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
